export enum MedicalRecordType {
  EXAMINATION = 'examination',
  TREATMENT = 'treatment',
  SURGERY = 'surgery',
  LAB = 'lab',
  IMAGING = 'imaging',
  VACCINATION = 'vaccination',
  EUTHANASIA = 'euthanasia',
  OTHER = 'other',
}

export enum PreventiveTreatmentCategory {
  VACCINATION = 'vaccination',
  ENDOPARASITE = 'endoparasite',
  ECTOPARASITE = 'ectoparasite',
  MEDICATION = 'medication',
}

export enum PreventiveTreatmentType {
  RABIES = 'rabies',
  DISTEMPER = 'distemper',
  HEPATITIS = 'hepatitis',
  PARVOVIROSIS = 'parvovirosis',
  LEPTOSPIROSIS = 'leptospirosis',
  KENNEL_COUGH = 'kennel_cough',
  FELINE_PANLEUKOPENIA = 'feline_panleukopenia',
  FELINE_HERPES = 'feline_herpes',
  FELINE_CALICI = 'feline_calici',
  FELINE_LEUKEMIA = 'feline_leukemia',
  MYXOMATOSIS = 'myxomatosis',
  RHD = 'rhd',
  EQUINE_INFLUENZA = 'equine_influenza',
  EQUINE_HERPES = 'equine_herpes',
  TETANUS = 'tetanus',
  ROUNDWORM = 'roundworm',
  TAPEWORM = 'tapeworm',
  GIARDIA = 'giardia',
  COCCIDIA = 'coccidia',
  FLEA = 'flea',
  TICK = 'tick',
  MITE = 'mite',
  OTHER = 'other',
}

export enum MedicalConditionKind {
  DIAGNOSIS = 'diagnosis',
  CHRONIC = 'chronic',
  ALLERGY = 'allergy',
  INTOLERANCE = 'intolerance',
  DISABILITY = 'disability',
  PREGNANCY = 'pregnancy',
}

export enum MedicalConditionSeverity {
  LOW = 'low',
  MEDIUM = 'medium',
  HIGH = 'high',
}

export enum QuarantineReason {
  RABIES_SUSPICION = 'rabies_suspicion',
  BITE_INCIDENT = 'bite_incident',
  INTAKE_OBSERVATION = 'intake_observation',
  CONTAGIOUS_DISEASE = 'contagious_disease',
  POST_SURGERY = 'post_surgery',
  OFFICIAL_ORDER = 'official_order',
  OTHER = 'other',
}

export enum DueTreatmentStatus {
  OVERDUE = 'overdue',
  DUE = 'due',
  UPCOMING = 'upcoming',
}

export function getMedicalRecordTypeLabelKey(value: MedicalRecordType | string | null | undefined): string {
  return `animalMedical.enum.recordType.${value ?? 'none'}`;
}

export function getPreventiveTreatmentCategoryLabelKey(value: PreventiveTreatmentCategory | string | null | undefined): string {
  return `animalMedical.enum.treatmentCategory.${value ?? 'none'}`;
}

export function getPreventiveTreatmentTypeLabelKey(value: PreventiveTreatmentType | string | null | undefined): string {
  return `animalMedical.enum.treatmentType.${value ?? 'none'}`;
}

export function getMedicalConditionKindLabelKey(value: MedicalConditionKind | string | null | undefined): string {
  return `animalMedical.enum.conditionKind.${value ?? 'none'}`;
}

export function getMedicalConditionSeverityLabelKey(value: MedicalConditionSeverity | string | null | undefined): string {
  return `animalMedical.enum.conditionSeverity.${value ?? 'none'}`;
}

export function getQuarantineReasonLabelKey(value: QuarantineReason | string | null | undefined): string {
  return `animalMedical.enum.quarantineReason.${value ?? 'none'}`;
}

export function getDueTreatmentStatusLabelKey(value: DueTreatmentStatus | string | null | undefined): string {
  return `animalMedical.enum.dueStatus.${value ?? 'none'}`;
}
